import { _ } from '../utils'
export default function InputReveal(el) {
    const target = _(el.dataset.target, 'element').node()
    const targetClass = target.dataset.class

    let newChoice = null
    const toggleClass = () => {
        if (el.type === 'select-one' && newChoice && !newChoice.checked) {
            return false
        }
        if ((el.type === 'select-one' && el.value === el.dataset.match) || (el.type === 'radio' && el.checked === true && el.dataset.country === el.dataset.match)) {
            target.classList.remove(targetClass)
        } else {
            target.classList.add(targetClass)
        }
    }

    el.addEventListener('change', toggleClass)
    newChoice?.addEventListener('change', toggleClass)

    setTimeout(() => {
        toggleClass()
    }, 500)
}
